import Api from "../apiService";

class tripPointsApi {
  index(companyId, tripId) {
    return Api.getRequest(
      `companies/${companyId}/trips/${tripId}/trip_points`,
      {},
      Api.authHeaders()
    );
  }

  show(companyId, tripId, pointId) {
    return Api.getRequest(
      `companies/${companyId}/trips/${tripId}/trip_points/${pointId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, tripId, tripPointData) {
    return Api.postRequest(
      `companies/${companyId}/trips/${tripId}/trip_points`,
      tripPointData,
      Api.authHeaders()
    );
  }

  update(companyId, tripId, pointId, tripPointData) {
    return Api.patchRequest(
      `companies/${companyId}/trips/${tripId}/trip_points/${pointId}`,
      tripPointData,
      Api.authHeaders()
    );
  }

  delete(companyId, tripId, pointId) {
    return Api.deleteRequest(
      `companies/${companyId}/trips/${tripId}/trip_points/${pointId}`,
      Api.authHeaders()
    );
  }

  reorder(companyId, tripId, tripPointData) {
    return Api.patchRequest(
      `companies/${companyId}/trips/${tripId}/trip_points/reorder`,
      tripPointData,
      Api.authHeaders()
    );
  }
}

export default new tripPointsApi();
